import React from "react";
import PropTypes from "prop-types";

//FIXME: SOF-617 requires the following imports to be moved to components/widget-components.scss
// due to lazy loading of the widget inside an iframe. Keeping this here for potential fix down the road.
// import 'components/questions/MatrixQuestionColumnHeaders.scss';

const MatrixQuestionColumnHeaders = ({ colId, columns }) => {
  return (
    <div className="csw-q-mtrx-headers">
      <div className="csw-q-mtrx-header csw-q-mtrx-header-space"> </div>
      {columns &&
        columns.map((column, index) => {
          const { text } = column;
          const hdrKey = `${colId}-${index}`;
          return (
            <div className="csw-q-mtrx-header" key={hdrKey}>
              {text}
            </div>
          );
        })}
    </div>
  );
};

MatrixQuestionColumnHeaders.propTypes /* remove-proptypes */ = {
  colId: PropTypes.string.isRequired,
  columns: PropTypes.array,
};

export default MatrixQuestionColumnHeaders;
